export default __webpack_public_path__ + "static/media/Rig Pirate.17be13e8.png";